import { render } from "./ConfirmationSent.vue?vue&type=template&id=4fa1c344&scoped=true"
const script = {}

import "./ConfirmationSent.vue?vue&type=style&index=0&id=4fa1c344&scoped=true&lang=css"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa1c344"]])

export default __exports__